<template>
  <LoaderWrapper ref="loader" class="h-100">
    <div class="col-sm-12">
      <div class="card card-body">
        <div class="overflow-auto">
          <table class="table table-striped border-light align-middle text-left text-nowrap position-relative">
            <thead>
            <tr>
              <th class="text-capitalize-first">{{ helper.trans('labels.id') }}</th>
              <th class="text-capitalize-first">{{ helper.trans('labels.email') }}</th>
              <th class="text-capitalize-first">{{ helper.trans('labels.currency') }}</th>
              <th class="text-capitalize-first">{{ helper.trans('labels.sum') }}</th>
              <th class="text-capitalize-first">{{ helper.trans('dashboard.on_hold') }}</th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="traderAccount in accountItems" :key="traderAccount.account.id" class="">
              <td>
                <span v-b-tooltip.hover :title="traderAccount.account.id">{{ traderAccount.account.id.substring(0, 8) }}...</span> <copy-button :value="traderAccount.account.id"></copy-button>
              </td>
              <td>
                {{ traderAccount.userEmail }}
              </td>
              <td>
                {{ traderAccount.account.currency }}
              </td>
              <td>
                {{ numberFormatter.formatNumber(traderAccount.account.sum) }}
              </td>
              <td>
                {{ numberFormatter.formatNumber(traderAccount.account.frozenSum) }}
              </td>
              <td class="text-end">
                <button v-if="accountForDetails !== null" type="button" @click.prevent="accountForDetails = null" class="btn btn-sm btn-outline-dark text-nowrap text-capitalize">
                  <i class="fa fa-arrow-left"></i> {{ helper.trans('button.back')}}
                </button>
                <button v-else @click.prevent="accountForDetails = traderAccount" class="btn btn-sm btn-outline-dark text-nowrap text-capitalize-first">
                  {{ helper.trans("menu.items.accountOperations") }}
                </button>
              </td>
            </tr>
            </tbody>
          </table>

          <b-pagination
            v-if="accounts.totalCount > accounts.items.length"
            v-model="page"
            :total-rows="accounts.totalCount"
            :per-page="accounts.limit"
            :limit="20"
            @update:modelValue="loadAccounts()"
            prev-text="Back"
            next-text="Next"
            align="start"
            first-number
            hide-goto-end-buttons
            hide-ellipsis
          ></b-pagination>

        </div>
      </div>
    </div>

    <AccountOperations v-if="accountForDetails" :account="accountForDetails.account" :class="'m-0'"></AccountOperations>

  </LoaderWrapper>
</template>

<script lang="ts">

import {computed, defineComponent, onMounted, ref} from 'vue'
import {helper} from "@/service/CommonHelper";
import {reactive, toRefs} from "@vue/reactivity";
import APIClient from "@/service/APIClient";
import LoaderWrapper from "@/components/LoaderWrapper.vue";
import {dateHelper} from "@/service/DateHelper";
import {numberFormatter} from "@/service/NumberFormatter";
import CopyButton from "@/components/CopyButton.vue";
import PaginatedResponseDTO from "@/models/PaginatedResponseDTO";
import TraderAccountDTO from "@/models/TraderAccountDTO";
import AccountOperations from "@/views/AccountOperations.vue";
import UserAccountDTO from "@/models/UserAccountDTO";

const api = new APIClient();

export default defineComponent({
  components: {
    LoaderWrapper,
    CopyButton,
    AccountOperations
  },
  props: {
    role: null
  },
  setup(props) {
    const loader = ref<InstanceType<typeof LoaderWrapper> | null>(null)

    const state = reactive({
      accountForDetails: null as UserAccountDTO|null,
      page: 1,
      accounts: {
        limit: 20,
        offset: 0,
        totalCount: 0,
        items: []
      } as PaginatedResponseDTO<UserAccountDTO>
    });

    const loadAccounts = async () => {
      loader.value?.show()
      state.accounts.offset = state.accounts.limit * (state.page - 1)
      state.accounts = await api.userAccounts(state.accounts, {userRole: props.role});
      loader.value?.hide()
    }

    const accountItems = computed<UserAccountDTO[]>(() => {
      if (state.accountForDetails === null) {
        return state.accounts.items
      }

      return [state.accountForDetails]
    })

    onMounted(() => {
      loadAccounts()
    });

    return {
      ...toRefs(state),
      loader,
      dateHelper,
      numberFormatter,
      helper,
      loadAccounts,
      accountItems
    }
  }
})
</script>
